import { Fragment } from "react";

export default function InputValidation({
  errorMessage,
  fontSize = "text-sm",
  className = "",
  iconIsInfo = true,
}) {
  return (
    <Fragment>
      {errorMessage ? (
        <div className={className}>
          <div
            className={`text-secondary ${fontSize} mt-regular items-start flex content-center gap-xx-small w-full`}
          >
            <span
              className={`material-symbols-outlined scale-75 ${iconIsInfo ? "text-blue" : "text-red"} align-bottom block`}
            >
              {iconIsInfo ? "info" : "error"}
            </span>{" "}
            <div
              className="w-[calc(100%-20px)] mt-[.15em]"
              style={{
                whiteSpace: "preWrap",
                wordWrap: "breakWord",
              }}
            >
              {errorMessage}
            </div>
          </div>
        </div>
      ) : null}
    </Fragment>
  );
}
